module.exports = __webpack_public_path__ + "img/1.eec1c2c7.svg";